module.exports = __webpack_public_path__ + "f79e21e95a87ceebf9670dc616ce5a5a.jpg";